<template>
    <div>

        <div id="home" class="section" v-observe-visibility="{
            callback: visibilityChanged,
            intersection: {
                threshold: 0.15
            }
        }">
            <div class="overlay opacity-50"></div>
            <lottie-player
                autoplay
                loop
                mode="normal"
                preserveAspectRatio="xMidYMid slice"
                src="https://cdn.sleepjar.com/sleepsounds/images/backgrounds/7x3/animated/simple/json/RainOverForest2.json"
                class="bg-lottie-player"
            />
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <!--
                        <h1 class="super color-white mb-5 d-lg-none"><img src="/images/app-icons/108/sleepsounds.png" class=""/></h1>
                        <h1 class="super color-white mb-10 d-lg-none">Sleep Jar<span class="trademark">®</span></h1>
                        -->
                        <h1 class="title color-white mb-5">Sleep sounds, stories, journeys, and meditations</h1>
                        <p class="lead mb-10">Sleep Jar is a leading app for audio content designed for sleep and mental wellness.</p>
                        <div class="row text-center">
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.quick_launch.alexa" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-amazon"></i>Alexa</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.android" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-android"></i>Android</a>
                            </div>
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.app_link.ios" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-apple"></i>iPhone</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.firetv" target="_blank" class="btn btn-lg btn-light"><i class="fas mr-2 fa-tv"></i>Fire TV</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center align-items-center">
                <i class="fab mr-2 fa-amazon"></i>
            </div>
        </div>

        <div id="soundlist" class="section bg-svg-beach">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Fall asleep to our beautiful sleep sounds</h1>

                        <div class="col-md-12 ml-auto mr-auto mb-7">
                            <div class="row">
                                <media-item v-for="(item, itemKey, index) in filteredMedia.SOUND"
                                    v-bind:emitConfig="emit_config"
                                    v-bind:item="item"
                                    v-bind:key="itemKey"
                                    v-bind:index="index"
                                    v-bind:itemKey="itemKey"
                                    v-bind:isShortlist="is_shortlist"
                                    v-bind:showDetailLink="true"
                                    ref="previews"
                                />
                            </div>
                        </div>
                        <router-link to="sounds" class="btn btn-lg btn-outline-light color-white">All sounds<i class="fas ml-2 fa-angle-double-right"></i></router-link>
                    </div>
                </div>
            </div>
        </div>

        <div id="storylist" class="section bg-svg-tanyawishes">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Stories to help you relax and unwind</h1>

                        <div class="col-md-12 ml-auto mr-auto mb-7">
                            <div class="row">
                                <media-artwork v-for="(item, itemKey, index) in filteredMedia.STORY"
                                    class="mb-3 col-sm-6 col-md-6 col-lg-3 mx-auto"
                                    v-bind:isShortlist="is_shortlist"
                                    v-bind:emitName="emit_config.emitter"
                                    v-bind:emitPool="emit_config.pool"
                                    v-bind:item="item"
                                    v-bind:itemKey="itemKey"
                                    v-bind:key="itemKey"
                                    v-bind:index="index"
                                    v-bind:showTypeBadge="false"
                                    v-bind:showCastButton="false"
                                    v-bind:showTitle="true"
                                    v-bind:showControls="false"
                                    v-bind:hoverEffect="true"
                                    v-bind:linkToDetail="true"
                                    ref="story-previews"
                                />
                            </div>
                        </div>
                        <router-link to="stories" class="btn btn-lg btn-outline-light color-white">All stories<i class="fas ml-2 fa-angle-double-right"></i></router-link>
                    </div>
                </div>
            </div>
        </div>

        <div id="journeylist" class="section bg-svg-skiingtetons">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Journeys to explore your imagination</h1>

                        <div class="col-md-12 ml-auto mr-auto mb-7">
                            <div class="row">
                                <media-artwork v-for="(item, itemKey, index) in filteredMedia.JOURNEY"
                                    class="mb-3 col-sm-6 col-md-6 col-lg-3 mx-auto"
                                    v-bind:isShortlist="is_shortlist"
                                    v-bind:emitName="emit_config.emitter"
                                    v-bind:emitPool="emit_config.pool"
                                    v-bind:item="item"
                                    v-bind:itemKey="itemKey"
                                    v-bind:key="itemKey"
                                    v-bind:index="index"
                                    v-bind:showTypeBadge="false"
                                    v-bind:showCastButton="false"
                                    v-bind:showTitle="true"
                                    v-bind:showControls="false"
                                    v-bind:hoverEffect="true"
                                    v-bind:linkToDetail="true"
                                    ref="journey-previews"
                                />
                            </div>
                        </div>
                        <router-link to="journeys" class="btn btn-lg btn-outline-light color-white">All journeys<i class="fas ml-2 fa-angle-double-right"></i></router-link>
                    </div>
                </div>
            </div>
        </div>

        <div id="meditationlist" class="section bg-svg-findingcalmness">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Meditations to calm your mind</h1>

                        <div class="col-md-12 ml-auto mr-auto mb-7">
                            <div class="row">
                                <media-artwork v-for="(item, itemKey, index) in filteredMedia.MEDITATION"
                                    class="mb-3 col-sm-6 col-md-6 col-lg-3 mx-auto"
                                    v-bind:isShortlist="is_shortlist"
                                    v-bind:emitName="emit_config.emitter"
                                    v-bind:emitPool="emit_config.pool"
                                    v-bind:item="item"
                                    v-bind:itemKey="itemKey"
                                    v-bind:key="itemKey"
                                    v-bind:index="index"
                                    v-bind:showTypeBadge="false"
                                    v-bind:showCastButton="false"
                                    v-bind:showTitle="true"
                                    v-bind:showControls="false"
                                    v-bind:hoverEffect="true"
                                    v-bind:linkToDetail="true"
                                    ref="meditation-previews"
                                />
                            </div>
                        </div>
                        <router-link to="meditations" class="btn btn-lg btn-outline-light color-white">All meditations<i class="fas ml-2 fa-angle-double-right"></i></router-link>
                    </div>
                </div>
            </div>
        </div>

        <div id="features" class="section bg-svg-healerhut">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title mb-10 color-white">Why millions of people choose Sleep Jar</h1>

                        <div class="mt-5 container">
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-moon mr-2"></i>{{ filteredMediaCount("SOUND") }} sleep sounds</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-book mr-2"></i>{{ filteredMediaCount("STORY") }} relaxing stories</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-spa mr-2"></i>{{ filteredMediaCount("MEDITATION") }} on-demand meditations</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-hiking mr-2"></i>{{ filteredMediaCount("JOURNEY") }} imaginative journeys</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-calendar-check mr-2"></i>Daily Meditations</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-random mr-2"></i>Mix content together</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-parachute-box mr-2"></i>Monthly content drops</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-signal mr-2"></i>Professional audio quality</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-clock mr-2"></i>Long loops</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-stopwatch mr-2"></i>Custom shut-off timer</span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-layer-group mr-2"></i>Cross-platform</span>
                                </div>
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-bed mr-2"></i>Promotes better sleep</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- 
        <div id="newsletter" class="section bg-svg-cozycove">
            <div class="overlay opacity-35"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Become an Insider</h1>
                        <p class="lead mb-10">Subscribe to be notified about new content and recommendations.</p>
                        <div>
                            <form  action="https://invokedapps.us3.list-manage.com/subscribe/post" method="POST">
                                <input type="hidden" name="u" value="e58fb0a07657d42085149a429">
                                <input type="hidden" name="id" value="5f9dd9ea57">
                                <div class="form-row justify-content-center">

                                    <div class="col-md-6 mb-5">
                                        <input type="email" class="form-control form-control-lg opacity-75" name="MERGE0" id="email" placeholder="Enter your email address" required>
                                    </div>
                                    <div class="col-md-auto">
                                        <button type="submit" class="btn btn-lg btn-outline-light color-white ml-auto mr-auto d-flex pointer"><i class="fas fa-lg-line mr-2 fa-paper-plane"></i>Subscribe</button>
                                    </div>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        -->


        <div id="newsletter" class="section bg-svg-critic">
            <div class="overlay opacity-75"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mega mb-5"><i class="fas fa-star color-gold"></i><i class="fas fa-star color-gold"></i><i class="fas fa-star color-gold"></i><i class="fas fa-star color-gold"></i><i class="fas fa-star color-gold"></i></h1>
                        <h3 class="title color-white mb-10">Sleep Jar has over 30,000 5-star ratings</h3>
                        <div class="row text-center">
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.quick_launch.alexa" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-amazon"></i>Alexa</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.android" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-android"></i>Android</a>
                            </div>
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.app_link.ios" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-apple"></i>iPhone</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.firetv" target="_blank" class="btn btn-lg btn-light"><i class="fas mr-2 fa-tv"></i>Fire TV</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>


<script>
    import { EventBus } from '../event-bus.js';
    export default {
        name: 'home',
        metaInfo: {
            //title: 'Sounds for sleep, relaxation, meditation, and focus',
            titleTemplate: null,
            meta: [
                {
                    'name': 'description',
                    'property': 'og:description',
                    'content': 'Sleep Jar is the best app for sleep sounds, stories, and guided meditations.'
                },
                {
                    'name': 'apple-itunes-app',
                    'content': 'app-id=1587218079'
                }
            ]
        },
        data () {
            return {
                "media": require('../assets/media.js'),
                "is_shortlist": true,
                "emit_config": {
                    "pool": "sounds",
                    "emitter": "sounds-stop"
                },
                "lotie_options": {
                    minimizable: false,
                    playerSize: "standard",
                    backgroundColor: '#fff',
                    backgroundStyle: 'color'
                }
            };
        },
        methods: {
            filteredMediaRoughCount (type = "SOUND") {
                return this.filteredMediaCount(type) - this.filteredMediaCount(type)%10;
            },
            filteredMediaCount (type = "SOUND") {
                var keys = Object.keys(this.filteredMedia[type]);
                return keys.length;
            },
            toggleShortlist () {
                this.is_shortlist = !this.is_shortlist;
            },
            visibilityChanged (isVisible, entry) {
                /*
                var element = document.getElementById(entry.target.id);
                var video = element.getElementsByTagName("video")[0];
                if(isVisible){
                    console.log("playing " + entry.target.id);
                    video.play();
                }else{
                    console.log("pausing " + entry.target.id);
                    video.pause();
                }
                */
            }
        },
        computed: {
            "filteredMedia": function(){
                let media = {
                    "SOUND": {},
                    "STORY": {},
                    "MEDITATION": {},
                    "JOURNEY": {}
                };
                Object.entries(this.media).forEach(function([key, item], index){
                    if(!item.published_ts || new Date(item.published_ts).getTime() < new Date().getTime()){
                        media[item.type][key] = item;
                    }
                });
                return media;
            }
        },
        components: {
        },
        mounted(){
            EventBus.$on(this.emit_config.emitter, function(index){
                this.$refs.previews[index].stopAudio();
            }.bind(this));
        }
    }
</script>
